import {
  FETCH_CHANGED_ITEMS_LIST_FAILED,
  FETCH_CHANGED_ITEMS_LIST_PENDING,
  FETCH_CHANGED_ITEMS_LIST_SUCCESS,
  FETCH_WORKFLOWS_FAILED,
  FETCH_WORKFLOWS_PENDING,
  FETCH_WORKFLOWS_SUCCESS,
} from '../actions/export.actions';
import {
  BULK_CHANGE_APP_MIGRATION_IMPORT_STATUSES,
  CHANGE_APP_MIGRATION_IMPORT_STATUS,
  CLEAR_APP_MIGRATION_IMPORT_ITEM,
  INITIATE_APP_MIGRATION_IMPORT_PROCESS,
  SET_APP_MIGRATION_CURRENT_IMPORT_KEY,
  SET_APP_MIGRATION_FILE_PACKAGE,
  SET_APP_MIGRATION_IMPORT_DATA,
  SET_APP_MIGRATION_IMPORT_ERROR,
  SET_APP_MIGRATION_IMPORT_LOADING,
  SET_APP_MIGRATION_IMPORT_STEP,
  SET_APP_MIGRATION_IS_NEW_IMPORT,
  SET_APP_MIGRATION_MODAL_IN_FILE_PROCESSING_STATE,
  SET_APP_MIGRATION_PROCESSED_ITEMS_TO_IMPORT,
  SET_APP_MIGRATION_TOTAL_ITEMS_TO_IMPORT,
  SET_APP_MIGRATION_UPLOAD_ITEMS,
  SET_APP_MIGRATION_ZIP_FIELD_ID,
} from '../actions/import.actions';
import { IMPORT_STEPS } from '../constants/import.constants';

const initialState = {
  import: {
    isNewImport: false,
    currentImportKey: null,
    importItems: {},
  },
  export: {
    changedItemsList: {},
    workflowsList: {},
  },
};

const initialImportConfig = {
  isLoading: false,
  importStep: 0,
  hasImportError: false,
  importKey: '',
  importStatuses: [],
  errorMessage: '',
  zipFieldId: '',
  filePackage: null,
  processedItems: 0,
  totalItems: 0,
};

const appMigration = (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_APP_MIGRATION_IMPORT_PROCESS: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: initialImportConfig,
          },
        },
      };
    }

    case SET_APP_MIGRATION_MODAL_IN_FILE_PROCESSING_STATE: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              isLoading: true,
              importStep: IMPORT_STEPS.FILE_PROCESSING,
              importKey: payload.importKey,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_IMPORT_STEP: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              importStep: payload.step,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_ZIP_FIELD_ID: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              zipFieldId: payload.id,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_FILE_PACKAGE: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              filePackage: payload.filePackage,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_UPLOAD_ITEMS: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              uploadItems: payload.items,
            },
          },
        },
      };
    }

    case CHANGE_APP_MIGRATION_IMPORT_STATUS: {
      const { payload } = action;

      const { importKey, id, key, value } = payload;

      const importStatuses = state.import.importItems[importKey].importStatuses.map((item) =>
        item.id === id ? { ...item, [key]: value } : item
      );

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [importKey]: {
              ...state.import.importItems[importKey],
              importStatuses,
            },
          },
        },
      };
    }

    case BULK_CHANGE_APP_MIGRATION_IMPORT_STATUSES: {
      const { payload } = action;

      const { importKey, key, ids, value } = payload;

      const importStatuses = state.import.importItems[importKey].importStatuses.map((item) =>
        ids.has(item.id)
          ? {
              ...item,
              [key]: value,
            }
          : item
      );

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [importKey]: {
              ...state.import.importItems[importKey],
              importStatuses,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_IMPORT_DATA: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              importKey: payload.importKey,
              importStatuses: payload.importStatuses,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_IMPORT_LOADING: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              isLoading: payload.flag,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_IMPORT_ERROR: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              hasImportError: payload.flag,
              errorMessage: payload.message,
            },
          },
        },
      };
    }

    case CLEAR_APP_MIGRATION_IMPORT_ITEM: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: initialImportConfig,
          },
        },
      };
    }

    case SET_APP_MIGRATION_IS_NEW_IMPORT: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          isNewImport: payload.flag,
        },
      };
    }

    case SET_APP_MIGRATION_CURRENT_IMPORT_KEY: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          currentImportKey: payload.importKey,
        },
      };
    }

    case SET_APP_MIGRATION_TOTAL_ITEMS_TO_IMPORT: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              totalItems: payload.count,
            },
          },
        },
      };
    }

    case SET_APP_MIGRATION_PROCESSED_ITEMS_TO_IMPORT: {
      const { payload } = action;

      return {
        ...state,
        import: {
          ...state.import,
          importItems: {
            ...state.import.importItems,
            [payload.importKey]: {
              ...state.import.importItems[payload.importKey],
              processedItems: payload.count,
            },
          },
        },
      };
    }

    case FETCH_CHANGED_ITEMS_LIST_PENDING:
      return {
        ...state,
        export: {
          ...state.export,
          changedItemsList: {
            ...state.export?.changedItemsList,
            isLoading: true,
          },
        },
      };
    case FETCH_CHANGED_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        export: {
          ...state.export,
          changedItemsList: {
            ...state.export?.changedItemsList,
            isLoading: false,
            data: action.payload ?? [],
          },
        },
      };
    case FETCH_CHANGED_ITEMS_LIST_FAILED:
      return {
        ...state,
        export: {
          ...state.export,
          changedItemsList: {
            ...state.export?.changedItemsList,
            isLoading: false,
            data: [],
            errors: action.payload,
          },
        },
      };
    case FETCH_WORKFLOWS_PENDING:
      return {
        ...state,
        export: {
          ...state.export,
          workflowsList: {
            ...state.export?.workflowsList,
            isLoading: true,
          },
        },
      };
    case FETCH_WORKFLOWS_SUCCESS:
      return {
        ...state,
        export: {
          ...state.export,
          workflowsList: {
            ...state.export?.workflowsList,
            isLoading: false,
            data: action.payload ?? [],
          },
        },
      };
    case FETCH_WORKFLOWS_FAILED:
      return {
        ...state,
        export: {
          ...state.export,
          workflowsList: {
            ...state.export?.workflowsList,
            isLoading: false,
            data: [],
            errors: action.payload,
          },
        },
      };

    default:
      return state;
  }
};

export default appMigration;
